<ng-container *ngIf="showSpotlight$ | async">
  <div class="spotlights">
    <atx-scroll-buttons
      [enableScrollButtons]="showSpotlightScrollButtons$ | async"
    >
      <atx-infinite-scroll
        (scrolled)="loadArticles()"
        class="spotlights-container d-flex no-scrollbar"
        [atxWheelHorizontalScroll]="{
          isDisabled: !wheelHorizontalScrollEnabled
        }"
      >
        <div class="container-fluid w-auto">
          <div
            data-e2e="spotlight-items-row"
            class="row flex-nowrap align-items-center"
          >
            <div
              *ngFor="let article of articles$ | async; trackBy: trackByFn"
              [childIndex]="
                (activeArticle$ | async)?.id === article.id ? 0 : -1
              "
              atxInfiniteScrollItem
              [atxScrollIntoView]="scrollIntoViewProps"
              class="col-auto"
              atxVisible
              [threshold]="1"
              [once]="true"
              [visibleEnabled]="isProductListReachedEventEnabled$ | async"
              (visible)="onVisible($event, article)"
            >
              <epc-spotlight-item
                (articleClick)="onArticleClick(article)"
                (pinStateChange)="togglePinState($event)"
                [article]="article"
                [isActive]="(activeArticle$ | async)?.id === article.id"
                [isAdmin]="isAdmin$ | async"
                (delete)="deleteSpotlightItem(article)"
                [attr.data-e2e]="'spotlight-item-' + title"
                class="spotlight-item my-2"
              >
                <span
                  badges
                  (visible)="markAsSeen(article.id)"
                  *ngIf="isNotSeen(article.id)"
                  @fade
                  [once]="true"
                  atxVisible
                  class="badge badge-pill badge-primary"
                  i18n="Spotlight|New item badge@@newItemBadge"
                >
                  New
                </span>
              </epc-spotlight-item>
            </div>
            <div *ngIf="loading$ | async" class="col-auto">
              <div
                class="spotlight-item d-flex justify-content-center align-items-center"
              >
                <fa-icon
                  [icon]="['fas', 'spinner']"
                  [spin]="true"
                  [pulse]="true"
                ></fa-icon>
              </div>
            </div>
          </div>
        </div>
      </atx-infinite-scroll>
    </atx-scroll-buttons>
  </div>
</ng-container>
